<app-page>
  <div class="col-12 lg:col-9 m-auto py-3 px-3">
    @if(linkingPlan) {
    <p-progressSpinner class="flex align-items-center justify-content-center"></p-progressSpinner>
    } @else {
    <p-card styleClass="bg-slate-100 p-0">
      @if(linkError){
      <p-message severity="error" [text]="linkError" icon="pi pi-ban" data-auto-id="link-error-message"
        styleClass="w-full justify-content-start"></p-message>
      }
      <!-- Welcome / Confirmation Card -->
      <p-card>
        <div class="flex flex-column gap-4 text-center">
          <div class="border-circle bg-emerald-50 w-fit m-auto p-2">
            <img src="assets/icons/Cinch_icon_Ribbon_Award.svg" alt="Confirmation" class="w-1/2 m-auto"
              style="max-width: 120px;" />
          </div>

          <h3 class="text-2xl text-center m-0">Welcome aboard!</h3>
          <p class="m-0 text-slate-800 text-sm md:text-base text-left">
            Your Electronics Essentials plan enrollment is complete. A confirmation has
            been sent to <span class="underline white-space-nowrap"> {{ emailAddress }}</span>
          </p>
        </div>
      </p-card>

      <!-- Plan Details Header & Print button -->
      <div class="flex flex-row justify-content-between align-items-center mt-4 mb-3">
        <h3 class="m-0">Plan details</h3>
        <p-button label="Print" rounded="true" severity="secondary" variant="outlined"
          styleClass="text-slate-800 bg-white text-base shadow-button w-full ml-0" icon="pi pi-print"
          class="w-6 sm:w-4 md:w-3" (click)="printPage()" />
      </div>

      <!-- Plan Details Panel -->
      <div class="mb-4">
        <p-panel [attr.aria-label]="'Selected product panel'" #panel [toggleable]="true" [collapsed]="false"
          collapseIcon="pi pi-angle-down" expandIcon="pi pi-angle-up">
          <ng-template pTemplate="header">
            <div class="flex w-full align-items-center" (click)="panel.toggle($event)">
              <div class="flex justify-content-center align-items-center bg-white w-3rem h-3rem">
                <img class="w-3rem h-3rem" src="assets/icons/shield-check.png" alt="Electronics Essentials Plan">
              </div>
              <div class="flex flex-column w-full ml-3">
                <p class="m-0 mb-2 text-slate-800 custom-bold">
                  Electronics Essentials Plan
                </p>
                <p class="m-0 text-slate-600 font-normal text-sm">
                  Contract number: {{ enrollmentInfo?.contractNumber }}
                </p>
                <p class="m-0 text-slate-600 font-normal text-sm">
                  Covered property: {{ contractData?.baseContract?.propertyAddress?.addressLine1 }}, {{
                  contractData?.baseContract?.propertyAddress?.city }}, {{
                  contractData?.baseContract?.propertyAddress?.state }} {{
                  contractData?.baseContract?.propertyAddress?.zip }}
                </p>
              </div>
            </div>
          </ng-template>

          <ng-template pTemplate="content">
            <p-divider class="m-0" />

            <!-- What to expect -->
            <div class="flex flex-column my-4">
              <p class="m-0 mb-1 text-slate-800 text-sm md:text-base custom-bold">What to expect</p>
              <ul class="my-2 pl-4">
                <li class="m-0 py-1 text-slate-800 text-sm md:text-base font-normal">Your new plan coverage begins after
                  the 30-day waiting period.</li>
                <li class="m-0 py-1 text-slate-800 text-sm md:text-base font-normal">Please allow up to one business day
                  for
                  your enrollment confirmation email to arrive.</li>
                @if (contentToBeDisplayed?.contact) {
                <li class="m-0 py-1 text-slate-800 text-sm md:text-base font-normal">If you have questions about your
                  plan,
                  feel free to reach out to us at {{ contentToBeDisplayed?.contact || '' }}.</li>
                }
                <li class="m-0 py-1 text-slate-800 text-sm md:text-base font-normal">Your plan is now available in your
                  My Account, making it easy to view and manage your plan anytime, online.</li>
              </ul>
            </div>

            <p-divider class="m-0" />

            <!-- Plan documents -->
            <div class="flex flex-column gap-2 my-4">
              <p class="m-0 text-slate-800 text-sm md:text-base custom-bold">
                Plan documents
              </p>
              <p class="m-0">
                You will receive your plan documents within 7-10 days of purchasing this plan. They will outline any
                exclusions and limitations that apply, including caps per claim and item.
              </p>
            </div>
          </ng-template>
        </p-panel>
      </div>

      <!-- Your Payment Summary Header -->
      <h3 class="mt-4 mb-3">Your payment summary</h3>

      <!-- Billing Method Details -->
      <p-card styleClass="mb-3">
        <div class="flex flex-column gap-3">
          <div class="flex flex-column gap-2">
            <p class="m-0 text-slate-800 text-xl custom-bold">Billing method</p>
            <p class="m-0 text-slate-700 text-sm">Billing frequency: Monthly</p>
          </div>
          <app-payment-type></app-payment-type>

        </div>
      </p-card>

      <!-- Total Cost Details -->
      <p-card>
        <div class="flex justify-content-between align-items-baseline">
          <div>
            <p class="m-0 text-slate-800 text-base md:text-lg lg:text-xl custom-bold">
              Total
            </p>
            <p class="m-0 py-1 text-sm white-space-nowrap text-slate-600">
              Payment date: {{ currentDate | date:'MM/dd/yyyy' }}
            </p>
          </div>

          <p class="m-0 text-slate-800 text-base md:text-lg lg:text-xl custom-bold">
            {{ totalMonthlyCost | currency }}
          </p>
        </div>
      </p-card>
    </p-card>

    <!-- Home Bottom Action -->
    <div class="col-12 p-0 mt-4">
      <p-button label='Home' [link]="true" (click)="navigateToDashboard()"
        class="flex align-items-center justify-content-center w-full m-auto mb-0" styleClass="pl-0 ml-0"
        icon="pi pi-home" />
    </div>
    }

    <div class="pt-4 lg:pt-6 text-slate-600">
      <p class="m-0 mt-2">{{ content.tnc.description }}</p>
    </div>
  </div>
</app-page>